
import sharedStyles from 'styles/css/SharedStyles.module.scss';
// import styles from 'styles/css/Main.module.scss';
// import drawerStyles from 'styles/css/Drawer.module.scss';
// import actionStyles from 'styles/css/ActionStyles.module.scss';
// import Logo from 'styles/images/logo/logo512.png';

import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import CeoImage from 'styles/images/aboutus/ceo.jpg';
import { Link } from 'react-router-dom';

const CeoResume = () => {

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtn />
                
                <div className={formStyles['text-center']}>
                    <img className={sharedStyles['w-full']} src={CeoImage} alt={"ceo image"} />
                    <span className={ruleStyles['font-weight-800']}>آن ذره که در حساب ناید</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>دکتر مسعود صفّار</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>نظام پزشکی : 65341</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>خاک پای مردم عزیز ایران</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>دانش آموخته دانشگاه علوم پزشکی شیراز</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>متولد شهرضا (قمشه)</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>(شهر اساتید گرانقدر دکتر  <span className={sharedStyles['text-green']}>مهدی و حسین الهی قمشه‌ای </span>)</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>۲۷ سال سابقه طبابت</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>حامی موسسات خیریه حمایت از ایتام عطر یاس نبوی</span>
                    <br />
                    <a href="https://yasnabavi.com" target="_blank">www.yasnabavi.com</a>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>خیریه کسا</span>
                    <br />
                    <a href="https://kassa-charity.org" target="_blank">www.kassa-charity.org</a>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>خیریه سالمندان کهریزک</span>
                    <br />
                    <a href="https://kahrizakcharity.com" target="_blank">www.kahrizakcharity.com</a>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>مدیر مسئول انتشارات ارم شیراز به مدت ۱۲ سال</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>معاون درمان اسبق هلال احمر استان فارس</span>
                    <br />

                    <Link to={`certificates`}>گواهینامه ها (Certificates)</Link>
                    <br />

                    <span className={ruleStyles['font-weight-800']}>ارتباط مستقیم با مديرعامل Dr20</span>
                    <br />
                    <span className={ruleStyles['font-weight-800']}>از طریق ارسال ایمیل به آدرس: <a href="mailto:dr20consult@gmail.com" target="_blank">dr20consult@gmail.com</a></span>
                </div>

            </div>
                
        </div>

    );
}

export default CeoResume;